<template>
  <div class="container" @click="flagOn">
    <section id="editContent" class="columnContainer">
      <div class="innerColumn">
        <h1 class="contentTitle">{{locale.product}} &#8250; {{productInfo.title}}</h1>
        <ItemList
          :locale="locale"
          :lang="lang"
          :list="list"
          :productInfo="productInfo"
          :category="productInfo.category"
          :itemByCategory="categoryGroups"
          :hasGuestType="hasGuestType"
          :submitCategory="submitCategory"
          :pIdType="pIdType"
          :requiredSubmitCategory="requiredSubmitCategory"
          :requiredPidType="requiredPidType"
          :ratio="thumbRatio"
          :prevMode="previewMode"
          @setPreviewMode="setPreviewMode"
          @updateItemManage="updateItemManage"
          @delManageInfo="delManageInfo"
          @addItem="addItem"
          @copyItem="copyItem"
          @delItem="delItem"
          @saveItem="save" />
      </div>
      <div class="innerSide"><div class="sideBox">
        <ProductFilter
          :locale="locale"
          :lang="lang"
          :category="productInfo.category"
          :itemByCategory="categoryGroups"
          @updateItemCategory="updateItemCategory" />
      </div></div>
    </section>
    <div id="setContent">
      <SettingItem
        :locale="locale"
        :lang="lang"
        :list="list"
        :setting="productInfo"
        :hasGuestType="hasGuestType"
        :submitCategory="submitCategory"
        :currentVer="originVer"
        :ratio="thumbRatio"
        :prevMode="previewMode"
        @updatePlace="updatePlace"
        @updatePromotion="updatePromotion"
        @applyAllItem="applyAll"
        @setThumbRatio="setThumbRatio"
        @setItemOrder="setOrder"
        @saveMemo="saveMemo"
        @loadVersion="loadVersion"
        @saveItem="save" />
    </div>
    <SetOrder v-if="order"
      :locale="locale"
      :lang="lang"
      @close="setOrder" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UNIQUE from '@/common/unique.js'
import LANG from '@/common/lang'
import regExp from '@/common/regExp'
import ItemList from '@/components/Product/ItemList'
import ProductFilter from '@/components/Product/Filter'
import SettingItem from '@/components/Product/SettingItem'
import SetOrder from '@/components/Product/SetOrder'

const defaultAvailable = function () {
  const list = [
    { id: 'mon', name: '월', available: true, time: [{ from: '00:00', to: '24:00' }] },
    { id: 'tue', name: '화', available: true, time: [{ from: '00:00', to: '24:00' }] },
    { id: 'wed', name: '수', available: true, time: [{ from: '00:00', to: '24:00' }] },
    { id: 'thu', name: '목', available: true, time: [{ from: '00:00', to: '24:00' }] },
    { id: 'fri', name: '금', available: true, time: [{ from: '00:00', to: '24:00' }] },
    { id: 'sat', name: '토', available: true, time: [{ from: '00:00', to: '24:00' }] },
    { id: 'sun', name: '일', available: true, time: [{ from: '00:00', to: '24:00' }] }
  ]
  return {
    state: '01',
    set: list
  }
}

export default {
  name: 'Product',
  components: {
    ItemList,
    ProductFilter,
    SettingItem,
    SetOrder
  },
  props: [
    'locale',
    'id',
    'isIdle'
  ],
  computed: {
    ...mapGetters({
      getSetting: 'setting/getData',
      orderList: 'product/getOrder',
      manageProduct: 'product/getManageProduct'
    }),
    lang () {
      return this.getSetting.lang
    },
    newItem () {
      return !this.id
    },
    submitCategory () {
      return this.$store.state.admin.submitCategory
    },
    requiredSubmitCategory () {
      return this.$store.state.admin.submitCateCheck
    },
    pIdType () {
      return this.$store.state.admin.pidType
    },
    requiredPidType () {
      return this.$store.state.admin.pidCheck
    },
    categoryGroups () {
      const category = this.productInfo.category.map(x => x.data.id)
      const list = this.list
      let group = []
      category.forEach(function (x) {
        const groupItem = {
          category: x,
          items: list.filter(item => item.info.category === x).map(i => i.id)
        }
        if (groupItem.items.length) {
          group.push(groupItem)
        }
      })
      return group
    },
    hasGuestType () {
      return this.$store.state.setting.guestType && this.$store.state.setting.guestType.length > 0
    }
  },
  watch: {
    '$route' (to, from, next) {
      const id = to.params.id
      this.getProductItem(id)
    }
  },
  created () {
    window.addEventListener('beforeunload', (e) => {
      if (this.dirtyFlag) {
        e.returnValue = '\\o/'
      }
    })
  },
  mounted () {
    this.init()
    
  },
  beforeRouteLeave (to, from, next) {
    const tryLogout = to.name === 'login'
    if (this.dirtyFlag && !this.isIdle && !tryLogout) {
      if (window.confirm(`${this.locale.confirm_leave}\n${this.locale.warn_leave}`)) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  data () {
    return {
      originVer: 0,
      lastVer: 0,
      isForce: false,
      dirtyFlag: false,
      order: false,
      previewMode: 'mobile',
      productInfo: {
        title: 'New Product',
        category: [
          {
            text: ' ',
            data: {
              id: '',
              label: 'uncategorized',
              image: []
            }
          }
        ],
        state: '01',
        submitTo: '',
        place: false,
        placeList: [],
        available: defaultAvailable(),
        viewType: 'grid',
        setDefaultImage: false
      },
      list: [],
      itemInfo: {
        isOpen: true,
        service: true,
        manage: false,
        disabled: false,
        thumb: '',
        thumbRatio: 'contain',
        submitTo: '',
        available: {},
        category: [],
        info: {
          name: this.$store.getters['setting/getLangValues'](),
          desc: this.$store.getters['setting/getLangValues'](),
          detail: this.$store.getters['setting/getLangValues'](),
          price: '',
          min: 1,
          max: 10,
          pName: 'New Item',
          pId: '',
          promotion: '',
          promotionCustom: false,
          promotionIcon: null,
          promotionSize: null,
          salePrice: '',
          manageInfo: {}
        },
        link: {
          id: '',
          type: 'outlink',
          pageId: '',
          target: false,
          url: this.$store.getters['setting/getLangValues']()
        },
        activeSort: false,
        displaySort: false,
        sortby: 'created'
      },
      thumbRatio: [
        { id: 'contain', label: 'contain' },
        { id: 'cover', label: 'cover' },
        { id: '75', label: '75%' },
        { id: '50', label: '50%' }
      ]
    }
  },
  methods: {
    track () {
      const site = this.$store.state.authentication.userInfo.siteid
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      const title = `product - ${this.itemInfo.info.pName}`
      this.$gtag.pageview({
        page_path: path,
        page_title: title
      })
    },
    async init () {
      const id = this.id
      this.dirtyFlag = false
      this.$store.dispatch('admin/getSubmitCategory')
      this.$store.dispatch('admin/getPidType')
      this.$store.dispatch('util/getSupportPlu')
      this.$store.commit('onLoading', true)
      await this.$store.dispatch('product/getProductSetting')
      if (this.newItem) {
        this.$store.commit('product/setFilter', { list: this.productInfo.category.map(x => x.data.id) })
        this.$store.commit('product/updateCategory', this.productInfo.category)
        this.$store.commit('onLoading', false)
      } else {
        this.getProductItem(id)
      }
    },
    setPreviewMode (mode) {
      this.previewMode = mode
    },
    getProductItem (id, version, site) { // version: 해당 페이지의 특정 버전이 필요할 때
      this.$store.dispatch('versionhistory/getFile', {
        file: `product/item/${id}.json`,
        ...version && {
          version: version
        },
        ...site && {
          site: site
        }
      }).then((res) => {
        if (res && res.data) {
            this.setItem(res.data)
          if (res.origin_version) {
            this.originVer = res.origin_version
          }
          if (res.last_version) {
            this.lastVer = res.last_version
          }
          if (this.$store.state.authentication.userInfo !== null) {
            this.track()
          }
          this.$store.commit('onLoading', false)
        } else {
          alert(this.locale.data_not_found)
          this.$router.replace('/product/list/1')
        }
      })
    },
    setProductOrder (orderArr, category) {
      const list = orderArr
      if (category && category.length) {
        const result = {}
        for (let i = 0; i < category.length; i++) {
          const cate = category[i]
          const cateId = cate.data.id
          result[cateId] = list.filter(x => {
            return x.category
              ? x.category.filter(c => cate.data.id === c || (cate.childrenIds && cate.childrenIds.includes(c))).length > 0
              : x.info.category
                ? cate.childrenIds && cate.childrenIds.includes(x.info.category)
                : false
          })
        }
        return result
      } else {
        return {
          unCategorized: list
        }
      }
    },
    setItem (data) {
      const categoryChildrenIds = function (arr) {
        let result = []
        const ids = function (arr) {
          arr.forEach(function (x) {
            if (x.children && x.children.length) {
              ids(x.children)
            }
            return result.push(x.data.id)
          })
          return result
        }
        return ids(arr)
      }
      function mergeOrder (orderlist, list, categoryAll) {
        const order = orderlist
        const items = list
        const itemsIds = items.map(x => x.id)
        let orderList
        if (Array.isArray(order)) { // (legacy) 상품순서
          const orderIds = order.map(x => x.id)
          const exist = order.filter(x => itemsIds.includes(x.id))
          const added = items.filter(x => !orderIds.includes(x.id))
          const ordered = function () {
            let result = []
            exist.forEach(function (item) {
              result.push(items.find(x => x.id === item.id))
            })
            return result
          }
          orderList = added.concat(ordered())
        } else { // (new) 상품순서
          if (Object.keys(order).length > 0) {
            Object.entries(order).forEach(([key, value]) => {
              const categories = categoryAll.find(x => x.data && x.data.id === key) && categoryAll.find(x => x.data && x.data.id === key).childrenIds // 자신과 children을 포함한 카테고리 id
              const orderIds = value.map(x => x.id)
              const exist = value.filter(x => itemsIds.includes(x.id))
              const added = items.filter(x => {
                return x.category &&
                  (x.category.includes(Number(key)) || (categories && categories.find(c => x.category.includes(c)))) &&
                  !orderIds.includes(x.id)
              })
              const ordered = function () {
                let result = []
                exist.forEach(function (item) {
                  result.push(items.find(x => x.id === item.id))
                })
                return result
              }
              order[key] = added.concat(ordered())
            })
            orderList = order
          }
        }
        return orderList
      }
      this.$store.commit('product/setOrder', [])
      this.$store.commit('product/setOrder', {})
      this.$store.commit('onLoading', true)
      this.$store.dispatch('product/getManageProduct').then((manageList) => {
        this.productInfo = {
          ...data,
          activeSort: data.activeSort || false,
          displaySort: data.displaySort || false,
          sortby: data.sortby || 'created',
          setDefaultImage: data.setDefaultImage || false
        }
        this.productInfo.category = data.category.map(x => {
          return x.data
            ? x
            : { data: { ...x } }
        }).filter(c => c.data && c.data.id).map(x => {
          return {
            ...x,
            ...(x.children && x.children.length > 0) && {
              childrenIds: categoryChildrenIds(x.children)
            }
          }
        })
        this.list = data.items.map(x => {
          // 이용가능시간 단일설정 -> 다중설정 맵핑
          const available = {
            ...x.available,
            set: x.available.set.map(t => {
              const time = t.time || (t.timeFrom && t.timeTo && {
                time: [
                  {
                    from: t.timeFrom,
                    to: t.timeTo
                  }
                ]
              })
              return {
                ...t,
                ...time
              }
            })
          }
          // 카테고리 단일설정 -> 다중설정 맵핑 (info.category에서 category로 이동)
          let category = x.category || []
          if (!x.category) {
            if (x.info.category) {
              category.push(x.info.category)
            }
            if (x.info.category2) {
              category.push(x.info.category2)
            }
            if (x.info.category3) {
              category.push(x.info.category3)
            }
          }
          // category = category.map(x => {
          //   const categories = this.productInfo.category.map(c => {
          //     return c.data.id.concat(c.childrenIds)
          //   })
          // })
          // 이미지 크기 설정
          const thumbRatio = x.thumbRatio || 'contain'
          return {
            ...x,
            isOpen: false,
            available: available,
            category: category,
            thumbRatio: thumbRatio
          }
        })
        const setMergeOrder = mergeOrder(data.order, this.list, this.productInfo.category)
        const productOrder = Array.isArray(setMergeOrder) ? this.setProductOrder(setMergeOrder, this.productInfo.category) : setMergeOrder
        this.$store.commit('product/setItemList', this.list)
        this.$store.commit('product/setOrder', productOrder)
        this.$store.commit('product/updateCategory', this.productInfo.category)
        this.$store.commit('product/initFilter')
        this.$store.commit('onLoading', false)
      })
    },
    flagOn () {
      this.dirtyFlag = true
    },
    // 전송코드, 이용가능 시간 모든 아이템에 일괄적용
    applyAll (target) {
      const data = this.productInfo[target]
      this.list = this.list.map(item => {
        return {
          ...item,
          [target]: this._.cloneDeep(data)
        }
      })
    },
    setThumbRatio (ratio) {
      this.list = this.list.map(x => {
        return {
          ...x,
          thumbRatio: ratio
        }
      })
    },
    addItem () {
      const itemInfo = this._.cloneDeep(this.itemInfo)
      const newItem = Object.assign({ id: UNIQUE.fileid() }, itemInfo)
      newItem.available = this._.cloneDeep(this.productInfo.available)
      newItem.submitTo = this.productInfo.submitTo
      if (this.productInfo.guestType) {
        newItem.guestType = this._.cloneDeep(this.productInfo.guestType)
      }
      this.list.unshift(newItem)
    },
    copyItem (id) {
      const item = this._.cloneDeep(this.list.find(x => x.id === id))
      item.id = UNIQUE.fileid()
      this.list = [item].concat(this.list)
    },
    delItem (id) {
      this.list = this.list.filter(x => x.id !== id)
      // this.save()
    },
    updateCategory (categoryList) {
      this.productInfo.category = categoryList
    },
    updatePlace (placeList) {
      this.productInfo.placeList = placeList
    },
    updatePromotion () {
      const setting = this.$store.getters['product/getProductSetting']
      const promotionList = setting && setting.promotion
      const promotionInfo = function (id) {
        const item = promotionList && promotionList.find(x => x.id === id)
        return item && !item.default
          ? {
            promotionCustom: !item.default,
            promotionSize: item.size,
            promotionIcon: item.icon
          }
          : null
      }
      this.list = this.list.map(x => {
        return {
          ...x,
          info: {
            ...x.info,
            ...promotionInfo(x.info.promotion)
          }
        }
      })
    },
    updateItemCategory (id) {
      const category = this.categoryGroups.find(x => x.category === id)
      if (category && category.items.length) {
        const itemIds = category.items
        this.list.forEach(function (item) {
          if (itemIds.includes(item.id)) {
            item.info.category = ''
          }
        })
      }
    },
    updateItemManage (manageInfo) {
      const item = this.list.find(x => x.id === manageInfo.id)
      const manageData = manageInfo.data
      Object.keys(manageData).forEach(function (x) {
        item.info[x] = manageData[x]
      })
      item.manageInfo = manageData
    },
    delManageInfo (id) {
      const item = this.list.find(x => x.id === id)
      delete item.manageInfo
    },
    setOrder () {
      const categoryAll = this.productInfo.category
      if (this.list.filter(x => x.service).length > 0) {
        if (!this.order) {
          const order = this.orderList
          const items = this.list
          const itemsIds = items.map(x => x.id)
          if (Array.isArray(order)) { // (legacy) 상품순서
            const orderIds = order.map(x => x.id)
            const exist = order.filter(x => itemsIds.includes(x.id))
            const added = items.filter(x => !orderIds.includes(x.id))
            const ordered = function () {
              let result = []
              exist.forEach(function (item) {
                result.push(items.find(x => x.id === item.id))
              })
              return result
            }
            const orderList = added.concat(ordered())
            this.$store.commit('product/setOrder', orderList)
          } else { // (new) 상품순서
            let newOrder = {}
            if (categoryAll && categoryAll.length > 0) {
              categoryAll.forEach((cate) => {
                const key = cate.data && cate.data.id
                const value = order ? (order[key] || []) : []
                const categories = categoryAll.find(x => x.data && x.data.id === key) && categoryAll.find(x => x.data && x.data.id === key).childrenIds // 자신과 children을 포함한 카테고리 id
                const orderIds = value.map(x => x.id)
                const exist = value.filter(x => itemsIds.includes(x.id))
                const added = items.filter(x => {
                  return x.category &&
                    (x.category.includes(Number(key)) || (categories && categories.find(c => x.category.includes(c)))) &&
                    !orderIds.includes(x.id)
                })
                const ordered = function () {
                  let result = []
                  exist.forEach(function (item) {
                    result.push(items.find(x => x.id === item.id))
                  })
                  return result
                }
                newOrder[key] = added.concat(ordered())
              })
            } else {
              const ordered = order.unCategorized && order.unCategorized.map(x => x.id)
              const added = items.filter(x => ordered && !ordered.includes(x.id))
              newOrder.unCategorized = added.concat(order.unCategorized)
            }
            this.$store.commit('product/setOrder', newOrder)
          }
          this.$store.commit('product/setItemList', this.list)
        }
        this.order = !this.order
      } else {
        alert(this.locale.product_require_order)
      }
    },
    loadVersion (version, site, id) {
      const productId = id || this.id
      this.getProductItem(productId, version, site)
    },
    saveMemo (memo) {
      this.comment = memo
      this.save()
    },
    validatePids () {
      let result = true
      const isCheck = this.requiredPidType
      function isBlank (str) {
        return str ? regExp.replaceAllEmpty(str).length > 0 : false
      }
      if (isCheck) {
        const pIdTypes = this.pIdType.map(x => x.id)
        const checkList = this.list.filter(x => {
          return !(x.info.pId && x.info.pIdType && isBlank(x.info.pId) && isBlank(x.info.pIdType.id) && pIdTypes.includes(x.info.pIdType.id))
        })
        result = checkList.length === 0
      }
      return result
    },
    validateSubmit () {
      let result = true
      const isCheck = this.$store.state.admin.submitCateCheck
      function isBlank (str) {
        return str ? regExp.replaceAllEmpty(str).length > 0 : false
      }
      if (isCheck) {
        const categories = this.$store.state.admin.submitCategory.map(x => x.id)
        result = this.list.filter(x => {
          return !(x.submitCategory && isBlank(x.submitCategory.id) && categories.includes(x.submitCategory.id))
        }).length === 0
      }
      return result
    },
    validateOnSave () {
      if (this._.isEmpty(this.list)) {
        alert(this.locale.validate_product_empty)
        return false
      } else if (regExp.replaceAllEmpty(this.productInfo.title) === '') {
        alert(this.locale.validate_product_title)
        return false
      } else if (this.productInfo.submitTo.trim() === '') {
        alert(this.locale.validate_product_submit)
        return false
      } else if (!this.validatePids()) {
        alert(this.locale.validate_pidtype_empty)
        return false
      } else if (!this.validateSubmit()) {
        alert(this.locale.validate_submitcategory_empty)
        return false
      } else {
        return true
      }
    },
    save () {
      if (this.validateOnSave()) {
        const siteid = this.$store.state.authentication.userInfo.siteid
        const id = this.id || `${siteid}.${UNIQUE.mid()}`
        const data = {
          id: id,
          title: this.productInfo.title,
          created: this.newItem ? new Date().toISOString() : this.productInfo.created,
          updated: new Date().toISOString(),
          category: this.$store.getters['product/getCategory'],
          submitTo: this.productInfo.submitTo,
          available: this.productInfo.available,
          items: this.list,
          order: this.orderList,
          place: this.productInfo.place,
          placeList: this.productInfo.placeList,
          viewType: this.productInfo.viewType || 'grid',
          guestType: this.productInfo.guestType,
          ...this.productInfo.submitCategory && {
            submitCategoryId: this.productInfo.submitCategoryId,
            submitCategory: this.productInfo.submitCategory
          },
          activeSort: this.productInfo.activeSort || false,
          displaySort: this.productInfo.displaySort || false,
          sortby: this.productInfo.sortby || 'created',
          setDefaultImage: this.productInfo.setDefaultImage || false
        }
        const productData = {
          id: id,
          data: data
        }
        this.$store.commit('onLoading', true)
        this.$store.dispatch('versionhistory/setFile', {
          file: `product/item/${productData.id}.json`,
          data: productData.data,
          origin_version: this.originVer,
          last_version: this.lastVer,
          ...this.isForce && {
            force: this.isForce
          },
          ...this.comment && {
            comment: this.comment
          }
        }).then((res) => {
          // save page list
          if (res && res.status) {
            if (res.status === 200) {
              this.$store.dispatch('product/getProductList').then((res) => {
                const list = res || []
                const listItem = {
                  id: data.id,
                  title: data.title,
                  created: data.created,
                  updated: data.updated
                }
                const productList = list.filter(x => x.id !== data.id).concat(listItem)
                this.$store.dispatch('product/setProductList', productList).then((res) => {
                  alert(this.locale.complete_save)
                  this.dirtyFlag = false
                  this.$store.commit('onLoading', false)
                  if (this.newItem) {
                    this.$router.replace({ name: 'productItem', params: { id: data.id } })
                  } else {
                    this.getProductItem(data.id)
                  }
                })
              })
            } else if (res.status === 201) {
              alert(this.locale.nothing_changed)
              this.$store.commit('onLoading', false)
            } else if (res.status === 202) {
              if (window.confirm(`${this.locale.already_other_saved}\n${this.locale.ask_save_force}`)) {
                this.isForce = true
                this.save()
              }
              this.$store.commit('onLoading', false)
            }
          } else {
            alert(this.locale.unknown_error)
            this.$store.commit('onLoading', false)
          }
        })
      }
    }
  }
}
</script>
